module.exports = __webpack_public_path__ + "img/avatar-75.0a6e7df3.png";